import type { Components, Theme } from '@mui/material/styles';

export const checkboxTheme: Components<Theme>['MuiCheckbox'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.vars.palette.semantic.border.secondary,
      '&:is(:hover, .Mui-focusVisible):not(.Mui-checked, .MuiCheckbox-indeterminate)':
        {
          color: theme.vars.palette.semantic.border.primary
        },
      '&.Mui-disabled': {
        color: theme.vars.palette.semantic.icon.disabled
      }
    }),
    colorPrimary: ({ theme }) => ({
      '&.Mui-checked, &.MuiCheckbox-indeterminate': {
        color: theme.vars.palette.semantic.background.primary,
        '&:hover': {
          color: theme.vars.palette.semantic.background['primary-hover']
        }
      },
      '&.Mui-disabled': {
        color: theme.vars.palette.semantic.icon.disabled
      }
    })
  }
};
